<div class="login-wrapper">
  <!-- Left Panel: Login Form -->
  <div class="login-panel">
    <form [formGroup]="loginForm" (ngSubmit)="submit()" (keyup.enter)="submit()" class="login-form">

      <!-- User Avatar -->
      <div class="avatar-circle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
        </svg>
      </div>

      <!-- Username Input -->
      <div class="form-group">
        <div class="input-wrapper">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </span>
          <input
            type="text"
            class="form-control"
            formControlName="userName"
            [placeholder]="'users.login.usernamePlaceholder' | translate"
            autocomplete="username"
            maxlength="50"
          />
        </div>
        <app-control-error-display
          [control]="getControl('userName')"
          [customErrors]="usernameErrors">
        </app-control-error-display>
      </div>

      <!-- Password Input -->
      <div class="form-group">
        <div class="input-wrapper">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/>
            </svg>
          </span>
          <input
            [type]="hidePassword ? 'password' : 'text'"
            id="Password"
            class="form-control"
            formControlName="password"
            [placeholder]="'users.login.passwordPlaceholder' | translate"
            autocomplete="current-password"
            maxlength="50"
          />
          <a href="#" (click)="hidePasswordIcon(); $event.preventDefault()" id="ShowPassword" class="password-toggle">
            <i class="fa" [ngClass]="hidePassword ? 'fa-eye' : 'fa-eye-slash'"></i>
          </a>
        </div>
        <app-control-error-display
          [control]="getControl('password')"
          [customErrors]="passwordErrors">
        </app-control-error-display>
      </div>

      <!-- Login Button -->
      <div class="form-group">
        <button
          id="submit"
          type="submit"
          class="btn-login"
          [disabled]="!loginForm.valid || isLoading"
        >
          <span *ngIf="!isLoading">{{ 'login.Title' | translate }}</span>
          <span *ngIf="isLoading">
            <i class="fa fa-spinner fa-spin"></i> {{ 'users.login.loading' | translate }}
          </span>
        </button>
      </div>

      <!-- Forget Password -->
      <div class="forget-password">
        <a id="forgetpassword" routerLink="/forget-password">
          {{ 'User.forgetPassword' | translate }}
        </a>
      </div>

      <!-- Microsoft Sign-In -->
      <div class="divider">
        <span>{{ 'users.login.or' | translate }}</span>
      </div>

      <div class="microsoft-signin">
        <a href="#" (click)="signInWithMicrosoft(); $event.preventDefault()">
          <div class="sign-microsoft">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512"
            >
              <g>
                <path d="M.972 0h242.911v243.79H.972z" fill="#F25022"></path>
                <path d="M269.636 0h241.392v243.79H269.636z" fill="#7FBA00"></path>
                <path d="M.972 268.21h242.911V512H.972z" fill="#00A4EF"></path>
                <path d="M269.636 268.21h241.392V512H269.636z" fill="#FFB900"></path>
              </g>
            </svg>
            <span>{{ 'users.login.signInMicrosoft' | translate }}</span>
          </div>
        </a>
      </div>
    </form>
  </div>

  <!-- Right Panel: Hero Section -->
  <div class="hero-panel">
    <!-- Decorative wave blobs -->
    <div class="wave-blob wave-blob-1"></div>
    <div class="wave-blob wave-blob-2"></div>
    <div class="wave-blob wave-blob-3"></div>
    <div class="wave-blob wave-blob-4"></div>
    <div class="hero-content">
      <h1 class="hero-title">{{ 'users.login.heroPart1' | translate }}<br/><span class="text-accent">{{ 'users.login.heroAccent' | translate }}</span> {{ 'users.login.heroPart2' | translate }}</h1>
    </div>
  </div>
</div>
